import React from "react";

const FormFieldGroup = ({ label, value, gridClass = "col-md-3", tooltip }) => {
  return (
    <div className={`form-field-group ${gridClass}`}>
      <label className="field-label motif-body2-default-medium">{label}</label>
      <div
        className="field-value motif-body1-default-regular"
        title={tooltip || undefined}
      >
        {value || "--"}
      </div>
    </div>
  );
};

export default FormFieldGroup;
